




































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

interface WidgetObject {
  glossy: boolean
  size: string
}

@Component({
  components: {}
})
export default class WidgetCard extends Vue {
  @Prop({ default: 'ابزارک' }) label !: string
  @Prop({ default: 'small' }) size !: string
  @Prop({ default: false }) dark !: boolean
  @Prop({ default: false }) center !: boolean
  @Prop({ default: false }) glossiness !: boolean
  @Prop({ required: true }) id !: number
  widgetCache: Record<string, WidgetObject>
  widgetCacheKey: string = 'niknevis_widget_cache'

  widgetSize: string = this.size
  glossy = true

  mounted() {
    this.widgetCache = JSON.parse(localStorage.getItem(this.widgetCacheKey))
    if (!this.widgetCache) {
      let data: WidgetObject = { glossy: this.glossy, size: this.widgetSize }
      localStorage.setItem(this.widgetCacheKey, JSON.stringify({ [this.id]: data }))
    } else {
      if (this.widgetCache[this.id.toString()]) {
        this.glossy = this.widgetCache[this.id.toString()]['glossy']
        this.widgetSize = this.widgetCache[this.id.toString()]['size']
      } else {
        this.widgetCache[this.id] = { glossy: this.glossy, size: this.widgetSize }
        localStorage.setItem(this.widgetCacheKey, JSON.stringify(this.widgetCache))
      }
    }
  }

  onClick(size) {
    this.widgetSize = size
    this.widgetCache[this.id] = { glossy: this.glossy, size: this.widgetSize }
    localStorage.setItem(this.widgetCacheKey, JSON.stringify(this.widgetCache))
  }

  setGlossy() {
    this.glossy = !this.glossy
    this.widgetCache[this.id] = { glossy: this.glossy, size: this.widgetSize }
    localStorage.setItem(this.widgetCacheKey, JSON.stringify(this.widgetCache))
  }

}

